import React from 'react'
import styles from './Navbar.scss'
import { Icon } from 'common/Icon'
import cx from 'classnames'
import { CoreLink } from 'common/CoreLink'
import _ from 'lodash'
import { SigninButton } from 'common/SigninButton'
import Modal from 'react-modal'
import { getConsole } from 'lib/getConsole'
const console = getConsole('common', 'Navbar')

// DEPRECATED!
export class Navbar extends React.PureComponent {
  static defaultProps = {
    collapsePoint: 900
  }

  constructor (props) {
    super(props)
    this.state = {
      collapsed: window.innerWidth < props.collapsePoint,
      showModal: false
    }
    this._throttledOnResize = _.throttle(this.onResize)
  }

  componentDidMount = () => {
    window.addEventListener('resize', this._throttledOnResize)
    console.warn('common/Navbar is deprecated')
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this._throttledOnResize)
  }

  onResize = () => {
    const { collapsePoint } = this.props
    const collapsed = window.innerWidth < collapsePoint
    this.setState({
      collapsed,
      showModal: collapsed && this.state.showModal
    })
  }

  showModal = () => this.setState({ showModal: true })

  hideModal = () => this.setState({ showModal: false })

  render () {
    const { children, fixed, secondaryNav, bigFont } = this.props
    const { collapsed, showModal } = this.state

    const navbar = (
      <div>
        <div className={styles.mainWrap}>
          <div className={cx(styles.Navbar, fixed && styles.fixed, collapsed && styles.collapsed)} style={bigFont && { fontSize: '15px' }}>
            <a href='/' className={styles.brandingLink}>
              <Icon i='logo-rwgps-simplified' size={40} />
            </a>
            {!collapsed && <div className={styles.navbarContent}>
              {children}
            </div>}
            {collapsed && <div className={styles.signupAndBurger}>
              {!(window.rwgps.config && window.rwgps.config.currentUser) && <SigninButton />}
              {' '}
              {showModal
                ? <Icon i='ios-close' size={32} className={styles.burgerButton} onClick={this.hideModal} />
                : <Icon i='ios-menu' size={32} className={styles.burgerButton} onClick={this.showModal} />
              }
            </div>}
          </div>
        </div>
        {secondaryNav && !collapsed && <div className={cx(styles.Navbar, styles.secondaryNav)}>
          <div className={styles.navbarContent}>
            {secondaryNav}
          </div>
        </div>}
      </div>
    )

    if (showModal) {
      return (
        <MobileNavModal>
          {navbar}
          <div className={styles.mobileNavStacked} onClick={this.hideModal}>
            {secondaryNav}
            {children}
          </div>
        </MobileNavModal>
      )
    }

    return navbar
  }
}

const modalStyles = {
  overlay: {
    zIndex: 1002,
    backgroundColor: 'none',
    margin: 0,
    padding: 0
  },
  content: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: 0,
    padding: 0,
    background: '#F8F8F8',
    border: 'none'
  }
}
export const MobileNavModal = ({ children }) => (
  <Modal isOpen style={modalStyles} contentLabel='NavbarExpand'>
    {children}
  </Modal>
)

export const NavbarGroup = ({ children }) => (
  <ul className={styles.NavbarGroup}>
    {children}
  </ul>
)

export const NavbarLink = ({ to, ...props }) => (
  to
    ? <CoreLink to={to} {...props} activeClassName={styles.activeNavItem} />
    : <a {...props} className={cx(window.location.pathname === props.href && styles.activeNavItem)} />
)

export const NavbarTitle = ({ className, ...props }) => (
  <CoreLink {...props} className={cx(styles.NavbarTitle, className)} />
)

export { styles as navbarStyles }
